import React from "react";

const RINGS = 5;

const AppLoader: React.FC = () => (
  <div
    role="status"
    aria-label="Loading JuDI"
    className="fixed inset-0 flex flex-col items-center justify-center bg-warm-bg-base"
  >
    <div className="animate-loader-entrance flex flex-col items-center gap-12">
      <div className="loader-rings" aria-hidden="true">
        {Array.from({ length: RINGS }, (_, i) => (
          <div key={i} className={`loader-ring loader-ring-${i + 1}`} />
        ))}
      </div>
    </div>

    <span className="sr-only">Loading your tasks…</span>
  </div>
);

export default AppLoader;
